export class HealthUnitTemplate {
    public idHealthUnitTemplate: number;
    public idTemplate: number;
}